import { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { Ring } from "@uiball/loaders";
import { Controller } from "react-hook-form";

import Button from "../../button";
import TextField from "../../text-field";

import { logDebug, logError } from "../../../utils/logger";
import { isFalse, isTrue } from "../../../utils/validators";

function NewsletterForm(props) {
  const { form, loading, onValid, onInvalid } = props;
  const { control, formState, handleSubmit } = form;
  const { isLoading, isDirty, disabled } = formState;

  const { t } = useTranslation();

  const loadingForm = useMemo(() => {
    return [isTrue(loading), isTrue(isLoading)].some((i) => i);
  }, [loading, isLoading]);

  const disabledSubmit = useMemo(() => {
    return [isTrue(disabled), isFalse(isDirty), isTrue(loadingForm)].some(
      (i) => i
    );
  }, [loadingForm, disabled, isDirty]);

  const onCopyHandler = useCallback((evt) => {
    logDebug("NewsletterForm", "onCopyHandler", { evt: evt });
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }, []);

  const onPasteHandler = useCallback((evt) => {
    logDebug("NewsletterForm", "onPasteHandler", { evt: evt });
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }, []);

  const onValidHandler = useCallback(
    (data, evt) => {
      const handler = async (data, evt) => {
        if (!disabled) {
          onValid && onValid(data, evt);
        }
      };
      logDebug("NewsletterForm", "onValidHandler", { data: data, evt: evt });
      handler(data, evt);
    },
    [disabled, onValid]
  );

  const onInvalidHandler = useCallback(
    (errors, evt) => {
      const handler = async (errors, evt) => {
        if (!disabled) {
          onInvalid && onInvalid(errors, evt);
        }
      };
      logError("NewsletterRegForm", "onInvalidHandler", {
        errors: errors,
        evt: evt,
      });
      handler(errors, evt);
    },
    [disabled, onInvalid]
  );

  return (
    <div className="newsletter__container">
      {loadingForm && (
        <div className="newsletter__loading">
          <Ring size={100} lineWeight={5} speed={2} color="#777e8b" />
        </div>
      )}
      <form
        id="newsletter_unregister_form"
        className="newsletter__form"
        onSubmit={handleSubmit(onValidHandler, onInvalidHandler)}
      >
        <div className="field email1">
          <Controller
            name="email"
            control={control}
            disabled={disabled}
            render={({ field, fieldState, formState }) => (
              <TextField
                {...field}
                label={t("unreg_newsletter_dialog.form.email")}
                placeholder={t("unreg_newsletter_dialog.form.email")}
                autoComplete={"email"}
                error={fieldState?.error?.message}
                required
                onCopy={(evt) => onCopyHandler(evt)}
                onPaste={(evt) => onPasteHandler(evt)}
              />
            )}
          />
        </div>
        <div className="login__form__footer">
          <Button
            type="submit"
            text
            primary
            loading={loadingForm}
            disabled={disabledSubmit}
          >
            <span className="label">{t("button.send")}</span>
          </Button>
        </div>
      </form>
    </div>
  );
}

export default NewsletterForm;
